export const NAME_TAG = 'span';

export const DEFAULT_CLASS = 'info-stock-message';
